import { render } from "./TableFooterIndicator.vue?vue&type=template&id=0c05594c"
import script from "./TableFooterIndicator.vue?vue&type=script&lang=js"
export * from "./TableFooterIndicator.vue?vue&type=script&lang=js"

import exportComponent from "/home/nucleares/openmct/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__